export default function waitForElement(selector: string, timeout = 5000): Promise<Element | null> {
  return new Promise((resolve) => {
    const element = document.querySelector(selector);
    if (element) resolve(element);

    const observer = new MutationObserver(() => {
      const el = document.querySelector(selector);
      if (el) {
        observer.disconnect();
        resolve(el);
      }
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true,
    });

    setTimeout(() => {
      observer.disconnect();
      resolve(null); // Falhou após o timeout
    }, timeout);
  });
}

export async function waitForElementWithDefinition<T extends HTMLElement = HTMLElement>(
  selector: string,
  timeout = 5000,
): Promise<T | null> {
  // 1. Aguardar o elemento aparecer no DOM
  const el = await new Promise<HTMLElement | null>((resolve) => {
    const element = document.querySelector(selector);
    if (element) resolve(element as HTMLElement);

    const observer = new MutationObserver(() => {
      const found = document.querySelector(selector);
      if (found) {
        observer.disconnect();
        resolve(found as HTMLElement);
      }
    });

    observer.observe(document.body, { childList: true, subtree: true });

    setTimeout(() => {
      observer.disconnect();
      resolve(null);
    }, timeout);
  });

  if (!el) return null;

  // 2. Aguardar o custom element estar definido (se for um Web Component)
  const tagName = el.tagName.toLowerCase();
  if (customElements.get(tagName) === undefined) {
    try {
      await customElements.whenDefined(tagName);
    } catch (e) {
      return null;
    }
  }

  return el as T;
}
